import { useTranslation } from 'react-i18next';

import { TBucket } from '@crm/entities/deals-board';

export const BucketContext = ({ contextData }: { contextData: TBucket['context'] }) => {
    const { t } = useTranslation();

    if (!contextData) {
        return null;
    }
    return (
        <div className="flex flex-col items-center justify-center gap-1">
            <div className="flex items-center gap-1">
                <span className="w-1.5 h-1.5 shrink-0 rounded-full bg-smtr-main-green-100" />
                <span className="text-xs text-smtr-main-black-100">
                    {t('crm.deals.board.bucket.returnToday', {
                        count: contextData.returnCounts?.today,
                    })}
                </span>
            </div>
            <div className="flex gap-2 items-end">
                <div className="flex items-center gap-1">
                    <span className="w-1.5 h-1.5 shrink-0 rounded-full bg-smtr-board-orange-100" />
                    <span className="text-[10px] text-smtr-main-tertiary-100">
                        {t('crm.deals.board.bucket.returnSoon', {
                            count: contextData.returnCounts?.soon,
                        })}
                    </span>
                </div>
                <div className="flex items-center gap-1">
                    <span className="text-[10px] text-smtr-main-tertiary-100">
                        {t('crm.deals.board.bucket.returnLater', {
                            count: contextData.returnCounts?.later,
                        })}
                    </span>
                </div>
            </div>
        </div>
    );
};
